import {
  SSP_AD_MODES,
  SSP_PARTNER_AD_MODES,
  TRoundingRules,
  WEB_AUTO_LOGIN,
  YANDEX_AD_MODES,
} from '@web-catalog/types/omicron';

import {
  boolean,
  ConfigSchema,
  FieldValidator,
  InferConfigType,
  OmicronConfigResponseType,
  string,
  stringUnion,
  WithTypeCheck,
} from '@utils/omicron';

const isRoundingRule = (value: unknown): value is TRoundingRules[number] => {
  if (!value || typeof value !== 'object') {
    return false;
  }
  return 'min' in value && 'text' in value;
};

const RoundingRuleValidator: FieldValidator<TRoundingRules | boolean> = {
  is: (value): value is TRoundingRules | boolean => {
    if (typeof value === 'boolean') {
      return true;
    }
    if (Array.isArray(value)) {
      return value.every(isRoundingRule);
    }
    return false;
  },
  fallback: false,
};

export const OmicronConfigSchema = {
  IS_SHOW_APP_CARD_RATING: boolean(),
  WEB_TECHNICAL_WORKS: boolean(),
  WEB_AUTO_DOWNLOAD: boolean(),
  RULES_FOR_DOWNLOADS_COUNT_GAMES: RoundingRuleValidator,
  RULES_FOR_DOWNLOADS_COUNT_APPS: RoundingRuleValidator,
  WEB_SIMILAR_APPS_DISCLAIMER: boolean(),
  WEB_SEARCH_EXPS: string(),
  WEB_USE_NEW_DEEPLINK_SCHEME: boolean(),
  WEB_YANDEX_AD_MODE: stringUnion('none', YANDEX_AD_MODES),
  WEB_AUTO_LOGIN: stringUnion('none', WEB_AUTO_LOGIN),
  WEB_SHOW_HIDDEN_APP_IN_CATALOG: boolean(),
  WEB_ENABLE_FEATURING: boolean(),
  WEB_SHOW_APP_STUBS_IN_CATALOG: boolean(),
  WEB_ENABLE_IMAGE_PROXY: boolean(),
  WEB_ENABLE_SELECTIONS_STRAPI: boolean(),
  WEB_SSP_AD_MODE: stringUnion('none', SSP_AD_MODES),
  WEB_SSP_AD_PARTNER: stringUnion('none', SSP_PARTNER_AD_MODES),
  WEB_SSP_AD_WITH_AUTH: boolean(),
  WEB_SSP_SCRIPT_ENABLED: boolean(),
  WEB_YANDEX_AD_LEFT_SIDEBAR_ENABLED: boolean(),
  WEB_YANDEX_AD_RIGHT_SIDEBAR_ENABLED: boolean(),
  WEB_YANDEX_AD_APPS_LIST_ENABLED: boolean(),
  WEB_ENABLE_QR_INSTALL: boolean(),
  WEB_GAME_MARKINGS_ENABLED: boolean(),
  WEB_ENABLE_HIDDEN_EXCEPTIONS: boolean(),
  WEB_SEARCH_TAGS_ENABLED: boolean(),
  WEB_ENABLE_PREORDER: boolean(),
} satisfies ConfigSchema;

export type OmicronContent = InferConfigType<
  WithTypeCheck<typeof OmicronConfigSchema>
>;

export type OmicronFlags = keyof typeof OmicronConfigSchema;

export type OmicronDTO = OmicronConfigResponseType<OmicronContent>;
